import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/free-solid-svg-icons';

interface BusinessInfoProps {
    businessName: string | undefined;
    hasMultipleBusinesses: boolean | undefined;
}

export const BusinessInfo: React.FC<BusinessInfoProps> = ({ businessName, hasMultipleBusinesses }) => {
    const noBusiness = !hasMultipleBusinesses && (!businessName || businessName.trim().length === 0);

    const showWarningIcon = noBusiness || hasMultipleBusinesses;

    return (
        <div className='lending-limits-guarantorSummaryInfo-section'>
            <div>Business:</div>

            <div className='lending-limits-guarantorSummaryInfo-section-businessName'>
                <b>
                    {showWarningIcon && (
                        <FontAwesomeIcon
                            icon={faWarning}
                            style={{ color: '#db0007', paddingRight: '.5rem' }}
                        />
                    )}

                    {noBusiness ? 'No Business Provided' : hasMultipleBusinesses ? 'Multiple Businesses' : businessName}
                </b>
            </div>
        </div>
    );
};
